import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { parse, ErrorCode, toBoundingBoxDegFloat } from './coords-parser';

@Component({
  selector: 'app-edit-coordinates-dialog',
  templateUrl: './edit-coordinates-dialog.component.html',
  styleUrls: ['./edit-coordinates-dialog.component.css']
})
export class EditCoordinatesDialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<EditCoordinatesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any) { }

  coordinates = "";
  parsingError;
  coordsBb;

  ngOnInit() {
    // prefill with the currently stored value so it can be edited (the decimal
    // bounding box output format is also a valid input, so it re-parses cleanly)
    if (this.data && this.data.coordinates) {
      this.coordinates = this.data.coordinates;
    }
    this.validate();
  }

  save() {
    this.dialogRef.close({
      coordinates: this.coordsBb,
    });
  }

  validate() {
    //console.log("validating")
    //  E 150°50'00"--E 160°50'00"/N 49°30'00"--N 48°30'00"
    if (!this.coordinates) {
      // this.parsingError = "Can't be empty"; //TODO: translate
      this.coordsBb = "";
      this.parsingError = undefined;
    } else {
      const parsed = parse(this.coordinates)
      if (parsed.ok) {
        this.parsingError = undefined;
        this.coordsBb = toBoundingBoxDegFloat(parsed.value.coords);
      } else {
        let errorType;
        switch (parsed.error.code) {
          case ErrorCode.INVALID_SYNTAX: {
            errorType = "Invalid syntax"; //TODO: translate
            break;
          }
          case ErrorCode.INCORRECT_VALUE: {
            errorType = "Incorrect value"; //TODO: translate
            break;
          }
        }
        this.parsingError = parsed.error.message ? (errorType + ": " + parsed.error.message) : errorType;
      }
    }
  }

}
